module.exports = __webpack_public_path__ + "static/media/16.bfef8bc1.JPG";